var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"element",staticClass:"lazy-image",class:{'is-loading': !_vm.active}},[_c('Transition',{attrs:{"name":"fade"}},[(_vm.active)?_c('img',{class:_vm.orientationClass,attrs:{"src":_vm.url,"alt":_vm.description,"draggable":"false"}}):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }